import {
  Anchor,
  Avatar,
  Card,
  CardProps,
  Flex,
  Paper,
  PaperProps,
  Text,
  Title,
} from "@mantine/core";
import { User } from "entities/user";
import { useState } from "react";
import { Link } from "react-router-dom";

export const DetailsPair = ({
  containerProps,
  children,
}: {
  containerProps?: PaperProps;
  children: React.ReactNode;
}) => {
  return (
    <Paper withBorder {...containerProps}>
      <Flex
        justify={"space-between"}
        align={"center"}
        sx={(theme) => ({
          padding: theme.spacing.xs,
        })}
      >
        {children}
      </Flex>
    </Paper>
  );
};

export const DetailsCard = ({
  containerProps,
  title,
  defaultCollapsed,
  children,
}: {
  containerProps?: Omit<CardProps, "children">;
  title?: string;
  defaultCollapsed?: Boolean;
  children: React.ReactNode;
}) => {
  const [collapsed, setCollapsed] = useState(defaultCollapsed);

  return (
    <Card withBorder {...containerProps}>
      {title && (
        <Card.Section onClick={() => setCollapsed(!collapsed)} withBorder>
          <Title
            order={5}
            align="center"
            sx={(theme) => ({
              color:
                theme.colorScheme === "dark"
                  ? theme.colors.cyan[4]
                  : theme.colors.cyan[6],
            })}
          >
            {title}
          </Title>
        </Card.Section>
      )}
      {!collapsed && <Card.Section p="sm">{children}</Card.Section>}
    </Card>
  );
};

export const DetailsUserCard = ({ user }: { user: User }) => {
  return (
    <Link to={`/users/show/${user.id}`} style={{ textDecoration: "none" }}>
      <Card withBorder>
        <Flex my="lg" gap="lg">
          <Avatar src={user?.image} size="lg" />
          <Flex direction="column">
            <Text size="lg" color="cyan">
              {user?.email}
            </Text>
            <Flex gap="xs" justify="flex-start">
              <Text size="sm">{user?.first_name}</Text>
              <Text size="sm">{user?.last_name}</Text>
            </Flex>
          </Flex>
        </Flex>
      </Card>
    </Link>
  );
};
